// ---------- START IMPORT BLOCK ----------
import React from "react";
import WhitelistWidget from "../Widgets/LoggedUserGeneral/WhitelistForm/WhitelistWidget";
import AddressForm from "../Widgets/LoggedUserGeneral/AddressesForm/AddressesForm";
import ContactInfoWidget from "../Widgets/LoggedUserGeneral/ContactInfoWidget/ContactInfoWidget";
import ResultsPage from "../MedicSearchForm/SearchResults";
import GeneralSettings from "../Widgets/LoggedUserGeneral/GeneralSettings/GeneralSettings";
import SummaryForm from "../Forms/Professional/summaryForm";
import DiagnosisForm from "../DiagnosisForm/diagnosisForm";
import CalendarForm from "../FormCalendar/CalendarForm";
import DentistryForm from "../DentistryForm/DentistryForm";
import ProfessionalMenu from "../Widgets/Professional/ProfessionalMenu/ProfessionalMenu";

import { useDashboardPreference } from "../../API/Context/AppUIContext";
import { ContentNames, GeneralContentNames } from "../../ConfigFiles/content_names/content_names.js";
// ---------- END IMPORT BLOCK ----------

interface ContentAreaProps {
  activeItem: string;
  initialAddUser?: string | null | undefined;
}

const ContentArea: React.FC<ContentAreaProps> = ({ activeItem, initialAddUser }) => {
  const { isProDashboardActive } = useDashboardPreference();

  // Render maps
  const renderGeneralUserContent = (key: string) => {
    switch (key) {
      case GeneralContentNames.SEARCH:
        return <ResultsPage />;
      case GeneralContentNames.SUMMARY:
        return <SummaryForm />;
      case GeneralContentNames.ADDRESSES:
        return <AddressForm />;
      case GeneralContentNames.EMERGENCY_CONTACTS:
        return <ContactInfoWidget />;
      case GeneralContentNames.SETTINGS:
        return <GeneralSettings />;
      case GeneralContentNames.PRIVACY:
        return <WhitelistWidget initialUsername={initialAddUser} />;
      case GeneralContentNames.BILLING:
        return <p className="p-4">BILLING</p>;
      default:
        return null;
    }
  };

  const renderMedStaffContent = (key: string) => {
    switch (key) {
      case ContentNames.PROFILE:
        return <ProfessionalMenu />;
      case ContentNames.DIAGNOSIS:
        return <DiagnosisForm />;
      case ContentNames.SUMMARY:
        return <SummaryForm />;
      case ContentNames.AGENDA:
        return <CalendarForm />;
      case ContentNames.DENTISTRY:
        return <DentistryForm />;
      default:
        return null;
    }
  };

  const content = isProDashboardActive
    ? renderMedStaffContent(activeItem)
    : renderGeneralUserContent(activeItem);

  return (
    <div>
      {content || (
        <div className="alert alert-info p-5 bg-white shadow-lg rounded-lg">
          <h4 className="alert-heading text-xl font-bold text-gray-800">Welcome to your Dashboard!</h4>
          <p className="text-gray-600 mt-2">
            Please select an item from the sidebar to view the corresponding management area.
          </p>
        </div>
      )}
    </div>
  );
};

export default ContentArea;